import { createAction } from '@reduxjs/toolkit'
import { TSlice } from 'types/GlobalSlice'

// tryGetAllSlices
export const getAll = createAction('get_all_slices')
export const getAllSuccess = createAction<TSlice[]>('get_all_slices_success')
export const getAllFailed = createAction('get_all_slices_failed')

// tryCreateSlice
export const create = createAction('create_slice')
export const createSuccess = createAction<TSlice>('create_slice_success')
export const createFailed = createAction('create_slice_failed')

// tryUpdateSlice
export const update = createAction('update_slice')
export const updateSuccess = createAction<TSlice>('update_slice_success')
export const updateFailed = createAction('update_slice_failed')

// tryDeleteSlice
export const destroy = createAction('delete_slice')
export const destroySuccess = createAction<{ id: string }>(
  'delete_slice_success'
)
export const destroyFailed = createAction('delete_slice_failed')
